export const imagenUtils = {

    removeImagemTexto(htmlString, imageIdentifier) {
        
        if (!htmlString || !imageIdentifier) return htmlString;
        
        // Normaliza o identificador (remove barras invertidas e pega apenas o nome do arquivo)
        const cleanIdentifier = imageIdentifier.replace(/\\/g, '/');
        const fileName = cleanIdentifier.split('/').pop();
        
        // Padrão 1: URL normal (após salvar) - com ou sem barras, com ou sem domínio
        const patterns = [
            // Caminho com barras normais: src="uploads/arquivo.png"
            new RegExp(`<img[^>]*src="[^"]*${cleanIdentifier.replace(/\//g, '\\/')}[^"]*"[^>]*>`, 'g'),
            
            // Caminho com barras invertidas: src="uploads\\arquivo.png"
            new RegExp(`<img[^>]*src="[^"]*${imageIdentifier.replace(/\\/g, '\\\\')}[^"]*"[^>]*>`, 'g'),
            
            // Apenas pelo nome do arquivo (qualquer caminho)
            new RegExp(`<img[^>]*src="[^"]*${fileName}[^"]*"[^>]*>`, 'g'),
            
            // Qualquer URL que contenha o nome do arquivo (com ou sem aspas)
            new RegExp(`<img[^>]*src=['"][^'"]*${fileName}[^'"]*['"][^>]*>`, 'g'),
        ];
        
        let result = htmlString;
        
        // Aplica todos os padrões para URLs normais
        patterns.forEach(pattern => {
            result = result.replace(pattern, '');
        });
        
        // Padrão 2: Imagem Base64 (antes de salvar)
        // Detecta qualquer tag img que contenha data:image
        const base64Pattern = /<img[^>]*src="data:image\/[^"]*base64[^"]*"[^>]*>/gi;
        result = result.replace(base64Pattern, '');
        
        // Limpa espaços ou tags vazias que possam ter sobrado
        result = result.replace(/<p>\s*<\/p>/g, ''); // Remove parágrafos vazios
        result = result.replace(/\n\s*\n/g, '\n'); // Remove linhas vazias duplicadas
        
        return result.trim();
    }
};

export default imagenUtils;